export const ACTIVE_TENANT_COUNT_API_ROUTE = `/next/api/common/active-tenant-count`;
